<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: 'categories',
        data () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// Categories.vue?6539f077